<div class="flex flex-col flex-1 gap-0 h-min">
  @if (item.config.title) {
    <div>
      <span class="text-base font-medium text-slate-900">{{
        item.config.title
      }}</span>
    </div>
  }
  <ng-container
    [ngTemplateOutlet]="templateOutlet"
    [ngTemplateOutletContext]="{
      $implicit: item.config?.group || [],
      groupName: 'report-designer',
      groupTarget: item.config.name,
      scrollable: false,
      cols: '4',
      level: level + 1,
      parentName: item.config.name,
      readOnly: readOnly
    }"
  ></ng-container>
</div>
